import { formateInputBlurNumber, formateInputNumber } from '@leprecoins/utility';
import { clamp } from '@mantine/hooks';
import { createEvent, createStore, sample } from 'effector';
import { and, equals } from 'patronum';
import { gameModel, ONBOARDING_STEPS } from 'entities/game';
import { createModalSwitcher } from 'shared/lib';
import { CALCULATOR_KEYS, CalculatorKey } from '../config';

const switcher = createModalSwitcher();

const $wager = createStore('0');

const $enableOnboardingCalculator = and(
	gameModel.$isOnboarding,
	equals(gameModel.$onboardingStep, ONBOARDING_STEPS.BET_CALCULATOR),
);

const keyClicked = createEvent<CalculatorKey>();

const digitKeyClicked = keyClicked.filter({
	fn: (key) =>
		(
			[
				CALCULATOR_KEYS.one,
				CALCULATOR_KEYS.two,
				CALCULATOR_KEYS.three,
				CALCULATOR_KEYS.four,
				CALCULATOR_KEYS.five,
				CALCULATOR_KEYS.six,
				CALCULATOR_KEYS.seven,
				CALCULATOR_KEYS.eight,
				CALCULATOR_KEYS.nine,
				CALCULATOR_KEYS.zero,
				CALCULATOR_KEYS.dot,
			] as CalculatorKey[]
		).includes(key),
});

const minKeyClicked = keyClicked.filter({ fn: (key) => key === CALCULATOR_KEYS.min });

const maxKeyClicked = keyClicked.filter({ fn: (key) => key === CALCULATOR_KEYS.max });

const deleteKeyClicked = keyClicked.filter({ fn: (key) => key === CALCULATOR_KEYS.delete });

const fastBetButtonClicked = createEvent<number>();

const calculatorBetFormSubmitted = createEvent();

sample({
	clock: switcher.enabled,
	source: gameModel.$wager,
	target: $wager,
});

sample({
	clock: digitKeyClicked,
	source: {
		wager: $wager,
		minBet: gameModel.$minBet,
		maxBet: gameModel.$maxBet,
	},
	fn: ({ wager, maxBet, minBet }, key) =>
		formateInputNumber(`${wager}${key}`, maxBet, minBet, false, 1),
	target: $wager,
});

sample({
	clock: minKeyClicked,
	source: gameModel.$minBet,
	fn: String,
	target: $wager,
});

sample({
	clock: maxKeyClicked,
	source: gameModel.$maxBet,
	fn: String,
	target: $wager,
});

sample({
	clock: deleteKeyClicked,
	source: $wager,
	fn: (wager) => wager.slice(0, -1),
	target: $wager,
});

sample({
	clock: fastBetButtonClicked,
	source: {
		minBet: gameModel.$minBet,
		maxBet: gameModel.$maxBet,
	},
	fn: ({ minBet, maxBet }, fastBet) => `${clamp(fastBet, minBet, maxBet)}`,
	target: $wager,
});

sample({
	clock: calculatorBetFormSubmitted,

	source: {
		wager: $wager,
		minBet: gameModel.$minBet,
		maxBet: gameModel.$maxBet,
	},
	fn: ({ wager, minBet, maxBet }) => formateInputBlurNumber(wager, maxBet, minBet, true),
	target: [switcher.disable, gameModel.$wager],
});

export const calculatorBetModel = {
	switcher,
	$wager,
	keyClicked,
	fastBetButtonClicked,
	calculatorBetFormSubmitted,
	$enableOnboardingCalculator,
};
